export { default } from './RateCard';
